module.exports = __webpack_public_path__ + "img/product_card_bg.36acdc98.png";